// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1675":"b18b405e","3575":"ce044c50","3730":"b18b405e","4935":"08d55499","6782":"b18b405e","9159":"b18b405e"}[chunkId] + ".chunk.css";
};